module.exports = __webpack_public_path__ + "static/img/8.b70a144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userMethods/8.png
// module id = FCDE
// module chunks = 0